export const indexItems = [
  {
    id: 'idx-1',
    title: '暑期档热播大剧',
    tag: '热播中',
    tagColor: 'accent',
    count: 48,
    description: '2026年暑期档最全追剧指南，高分热剧一网打尽',
    icon: 'ri-fire-line',
  },
  {
    id: 'idx-2',
    title: '豆瓣高分经典',
    tag: '精选',
    tagColor: 'primary',
    count: 126,
    description: '评分8.5以上口碑佳作，每一部都值得反复观看',
    icon: 'ri-star-line',
  },
  {
    id: 'idx-3',
    title: '悬疑烧脑专区',
    tag: '热门',
    tagColor: 'secondary',
    count: 73,
    description: '反转不断的悬疑神剧，挑战你的推理极限',
    icon: 'ri-lightbulb-flash-line',
  },
  {
    id: 'idx-4',
    title: '韩剧精选合集',
    tag: '日更',
    tagColor: 'accent',
    count: 94,
    description: '最新韩剧同步更新，浪漫爱情与热血剧情全收录',
    icon: 'ri-heart-pulse-line',
  },
  {
    id: 'idx-5',
    title: '国漫崛起计划',
    tag: '推荐',
    tagColor: 'primary',
    count: 61,
    description: '国产动漫精品力作，画风精美剧情引人入胜',
    icon: 'ri-movie-line',
  },
  {
    id: 'idx-6',
    title: '动作科幻巨制',
    tag: '热映',
    tagColor: 'secondary',
    count: 55,
    description: '好莱坞与国产科幻大片，震撼视效酣畅淋漓',
    icon: 'ri-rocket-line',
  },
  {
    id: 'idx-7',
    title: '喜剧合家欢',
    tag: '欢乐',
    tagColor: 'accent',
    count: 82,
    description: '轻松搞笑的喜剧电影电视剧，全家一起笑出声',
    icon: 'ri-emotion-laugh-line',
  },
  {
    id: 'idx-8',
    title: '纪录片视野',
    tag: '深度',
    tagColor: 'primary',
    count: 39,
    description: '自然人文历史纪录片，打开认识世界的新视角',
    icon: 'ri-earth-line',
  },
];

export const carouselItems = [
  {
    id: 'car-1',
    title: '《云边有个小卖部》温情治愈，张嘉佳原著改编电影今日上线',
    category: '电影 · 剧情',
    description: '改编自张嘉佳同名小说，讲述云边镇少年刘十三的成长故事。彭昱畅、周也主演，温情与笑泪交织，带你回到那个山间小镇。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20mountain%20village%20scene%20with%20golden%20sunset%20light%2C%20traditional%20Chinese%20small%20town%2C%20nostalgic%20atmosphere%2C%20soft%20warm%20amber%20tones%2C%20dreamy%20evening%20mood%2C%20rolling%20hills%20and%20quaint%20buildings%2C%20film%20grain%20texture%2C%20artistic%20cinematic%20photography%20with%20gentle%20bokeh%20and%20harmonious%20composition&width=1200&height=600&seq=carousel-1-2026&orientation=landscape',
    stats: '豆瓣 8.7 · 今日最热',
    link: '#index',
  },
  {
    id: 'car-2',
    title: '《唐朝诡事录之西行》第二季强势回归，古装悬疑再掀热潮',
    category: '剧集 · 悬疑古装',
    description: '杨旭文、杨志刚主演，延续第一季精良制作。西域奇案环环相扣，诡谲氛围与大唐风华交相辉映，探案小分队再度集结。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20ancient%20Chinese%20Tang%20dynasty%20palace%20at%20night%2C%20lanterns%20and%20shadows%2C%20traditional%20costumes%2C%20foggy%20atmosphere%2C%20detective%20theme%2C%20warm%20amber%20and%20deep%20crimson%20lighting%2C%20historical%20mystery%20mood%2C%20cinematic%20composition%20with%20dramatic%20lighting%20and%20rich%20textures&width=1200&height=600&seq=carousel-2-2026&orientation=landscape',
    stats: '播放破 5 亿 · 口碑爆棚',
    link: '#index',
  },
  {
    id: 'car-3',
    title: '《沙丘：第三部》震撼来袭，史诗科幻终章引爆全球期待',
    category: '电影 · 科幻史诗',
    description: '丹尼斯·维伦纽瓦执导，提莫西·查拉梅、赞达亚回归。保罗·厄崔迪斯的命运终章，沙漠星球的故事迎来史诗级大结局。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20desert%20planet%20landscape%20with%20massive%20sand%20dunes%20under%20golden%20sun%2C%20science%20fiction%20atmosphere%2C%20dramatic%20cinematic%20lighting%2C%20warm%20amber%20and%20deep%20bronze%20tones%2C%20vast%20scale%2C%20mysterious%20and%20grand%20composition%2C%20film%20grain%20texture%2C%20high%20contrast%20shadows&width=1200&height=600&seq=carousel-3-2026&orientation=landscape',
    stats: '全球票房预测 10 亿+',
    link: '#index',
  },
  {
    id: 'car-4',
    title: '《漫长的季节》导演新作开拍，东北悬疑宇宙持续扩展',
    category: '剧集 · 犯罪悬疑',
    description: '辛爽导演继《漫长的季节》《隐秘的角落》后第三部悬疑力作。延续东北叙事美学，全新故事线与老戏骨阵容引期待。',
    image: 'https://readdy.ai/api/search-image?query=Moody%20northeastern%20Chinese%20industrial%20town%20in%20autumn%2C%20old%20factory%20buildings%2C%20falling%20leaves%2C%20overcast%20sky%20with%20soft%20light%2C%20mysterious%20and%20nostalgic%20atmosphere%2C%20warm%20sepia%20and%20muted%20amber%20tones%2C%20film%20noir%20style%2C%20cinematic%20photography%20with%20deep%20shadows%20and%20textured%20surfaces&width=1200&height=600&seq=carousel-4-2026&orientation=landscape',
    stats: '未拍先火 · 期待值拉满',
    link: '#index',
  },
  {
    id: 'car-5',
    title: '奥斯卡最佳动画《猫猫的奇幻漂流》治愈上映，全年龄段口碑佳作',
    category: '电影 · 动画冒险',
    description: '讲述一只家猫在洪水中的求生漂流之旅，无对白纯视觉叙事。画面美轮美奂，情感真挚动人，年度必看动画电影。',
    image: 'https://readdy.ai/api/search-image?query=Dreamy%20animated%20style%20cat%20on%20a%20small%20wooden%20boat%20drifting%20on%20calm%20floodwater%20with%20distant%20city%20silhouette%2C%20soft%20sunset%20golden%20light%2C%20water%20reflections%2C%20warm%20amber%20and%20gentle%20pastel%20tones%2C%20magical%20atmosphere%2C%20painterly%20art%20style%2C%20cinematic%20wide%20composition%20with%20harmonious%20color%20palette&width=1200&height=600&seq=carousel-5-2026&orientation=landscape',
    stats: '烂番茄 98% · 年度必看',
    link: '#index',
  },
  {
    id: 'car-6',
    title: '国产谍战剧《暗夜追踪》低调开播，零宣发凭口碑逆袭热搜',
    category: '剧集 · 谍战',
    description: '张译、王劲松领衔主演，讲述解放前夕上海地下党的隐秘战线故事。节奏紧凑演技炸裂，被观众称为"年度最佳谍战剧"。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%201940s%20Shanghai%20night%20street%20scene%20with%20old%20western%20style%20buildings%2C%20wet%20cobblestone%20road%2C%20dim%20street%20lamps%20glowing%2C%20vintage%20cars%2C%20noir%20atmosphere%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20spy%20thriller%20mood%2C%20cinematic%20film%20noir%20photography%20with%20dramatic%20lighting%20and%20fog&width=1200&height=600&seq=carousel-6-2026&orientation=landscape',
    stats: '开播 3 天热搜登顶',
    link: '#index',
  },
];

export const rankingItems = [
  { id: 'rank-1', rank: 1, title: '唐朝诡事录之西行', category: '古装悬疑', hotIndex: 9876, trend: 'up', badge: '新上榜' },
  { id: 'rank-2', rank: 2, title: '庆余年 第二季', category: '古装权谋', hotIndex: 9623, trend: 'stable', badge: '' },
  { id: 'rank-3', rank: 3, title: '云边有个小卖部', category: '温情剧情', hotIndex: 9401, trend: 'up', badge: '飙升' },
  { id: 'rank-4', rank: 4, title: '暗夜追踪', category: '谍战', hotIndex: 9158, trend: 'up', badge: '热议' },
  { id: 'rank-5', rank: 5, title: '猫猫的奇幻漂流', category: '动画冒险', hotIndex: 8927, trend: 'stable', badge: '' },
  { id: 'rank-6', rank: 6, title: '三体：大结局', category: '科幻巨制', hotIndex: 8744, trend: 'down', badge: '' },
];

export const aboutContent = {
  title: '关于爱看影院',
  paragraphs: [
    '爱看影院是国内领先的高清在线观影平台，致力于为影迷提供海量高清电影和高清电视剧的在线观看服务。我们坚持"高清画质、流畅秒播"的核心理念，让每一位观众都能享受影院级的观影体验。',
    '平台汇聚了来自全球的精选影视资源，覆盖剧情、科幻、悬疑、喜剧、动画、纪录片等全品类内容。每日更新最新热播剧集，确保你不错过任何一部好剧。无论你是喜欢追热门大剧，还是偏爱冷门佳片，爱看影院都能满足你的观影需求。',
    '我们采用先进的视频编码与CDN加速技术，确保高清视频不缓冲、不卡顿、秒开秒播。同时，平台界面简洁清爽，没有繁琐的广告打扰，让你专注于观影本身。爱看影院，让好电影触手可及。',
  ],
  stats: [
    { value: '10万+', label: '影视资源' },
    { value: '5000万+', label: '月活跃用户' },
    { value: '99.7%', label: '播放成功率' },
  ],
};

export const featureItems = [
  {
    id: 'feat-1',
    icon: 'ri-4k-line',
    title: '真高清画质',
    description: '支持1080P与4K超清播放，还原每一帧的细腻画质。自适应码率技术，根据网络状况智能切换最佳清晰度。',
  },
  {
    id: 'feat-2',
    icon: 'ri-flashlight-line',
    title: '秒播不缓冲',
    description: '全球CDN加速节点覆盖，智能预加载技术。点击即播无需等待，告别加载转圈，观影体验流畅到底。',
  },
  {
    id: 'feat-3',
    icon: 'ri-calendar-check-line',
    title: '每日更新',
    description: '热播剧集每日准时更新，同步追剧不掉队。新片速递专区第一时间上线最新电影资源，精彩从不迟到。',
  },
  {
    id: 'feat-4',
    icon: 'ri-shield-check-line',
    title: '纯净观影',
    description: '无弹窗广告、无漂浮广告、无强制跳转。清爽简洁的播放界面，让你沉浸在纯粹的观影世界。',
  },
  {
    id: 'feat-5',
    icon: 'ri-smartphone-line',
    title: '全终端适配',
    description: '电脑、平板、手机全终端完美适配。支持投屏到电视大屏，随时随地享受高清观影体验。',
  },
];

export const contactContent = {
  title: '联系我们',
  description: '如果你有影视资源推荐、合作意向或任何建议，欢迎随时联系我们',
  email: 'contact@aikanyingyuan.com',
  wechat: 'aikanyingyuan',
  qq: '4001234567',
  hours: '客服在线时间：每日 9:00 - 24:00',
};

export const mediaItems = [
  {
    id: 'med-1',
    title: '《云边有个小卖部》独家幕后特辑',
    duration: '15:32',
    views: '128万',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20production%20on%20a%20mountain%20village%20set%2C%20director%20talking%20with%20actors%2C%20warm%20golden%20hour%20lighting%2C%20Chinese%20countryside%20background%2C%20camera%20equipment%20visible%2C%20natural%20cinematic%20photography%20with%20soft%20shadows%20and%20harmonious%20warm%20amber%20tones&width=800&height=450&seq=media-1-2026&orientation=landscape',
    tag: '幕后花絮',
  },
  {
    id: 'med-2',
    title: '《唐朝诡事录之西行》主创访谈',
    duration: '22:08',
    views: '96万',
    image: 'https://readdy.ai/api/search-image?query=Two%20actors%20in%20traditional%20Tang%20dynasty%20Chinese%20costumes%20being%20interviewed%20in%20a%20warm%20studio%20setting%2C%20soft%20golden%20ring%20light%2C%20professional%20interview%20atmosphere%2C%20microphones%20visible%2C%20warm%20amber%20and%20deep%20red%20aesthetic%2C%20cinematic%20composition%20with%20rich%20textures%20and%20gentle%20bokeh&width=800&height=450&seq=media-2-2026&orientation=landscape',
    tag: '主创访谈',
  },
  {
    id: 'med-3',
    title: '《沙丘：第三部》终极预告解析',
    duration: '10:45',
    views: '235万',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20science%20fiction%20desert%20planet%20scene%20with%20massive%20sandworms%20and%20figures%20in%20still%20suits%2C%20golden%20dust%20storm%20atmosphere%2C%20epic%20scale%2C%20warm%20bronze%20and%20deep%20amber%20cinematic%20lighting%2C%20movie%20trailer%20aesthetic%2C%20high%20drama%20composition%20with%20dust%20and%20light%20rays&width=800&height=450&seq=media-3-2026&orientation=landscape',
    tag: '预告解析',
  },
  {
    id: 'med-4',
    title: '年度十佳国产剧 · 深度盘点回顾',
    duration: '18:20',
    views: '187万',
    image: 'https://readdy.ai/api/search-image?query=Aesthetic%20flat%20lay%20of%20Chinese%20film%20posters%20and%20movie%20memorabilia%20on%20a%20warm%20wooden%20desk%2C%20soft%20natural%20light%20from%20window%2C%20cozy%20atmosphere%2C%20warm%20amber%20and%20cream%20tones%2C%20film%20reels%20and%20tickets%20as%20props%2C%20editorial%20photography%20style%20with%20gentle%20shadows%20and%20harmonious%20composition&width=800&height=450&seq=media-4-2026&orientation=landscape',
    tag: '年度盘点',
  },
];

export const appContent = {
  title: '随时随地 高清追剧',
  subtitle: '下载爱看影院移动客户端，精彩影视装进口袋',
  features: [
    '离线缓存，无网络也能看',
    '投屏电视，大屏才过瘾',
    '消息提醒，更新不错过',
    '夜间模式，护眼更舒适',
  ],
  qrCodeDesc: '扫码下载 App',
  badgeDesc: '或在各大应用商店搜索"爱看影院"',
};

export const faqItems = [
  {
    id: 'faq-1',
    question: '爱看影院的视频画质怎么样？',
    answer: '爱看影院所有影视资源均支持高清播放，主流内容可达1080P全高清，部分精选影片提供4K超清画质。平台采用智能码率自适应技术，根据你的网络状况自动调整最佳清晰度，确保流畅观影体验。',
  },
  {
    id: 'faq-2',
    question: '观看视频需要付费吗？',
    answer: '爱看影院目前提供完全免费的在线观影服务，所有电影和电视剧均可免费观看。我们致力于让更多人享受高清影视的乐趣，未来如有会员增值服务将会提前公告通知。',
  },
  {
    id: 'faq-3',
    question: '为什么有些视频加载比较慢？',
    answer: '视频加载速度主要取决于你的网络环境。建议检查当前网络连接状态，尝试切换到更稳定的WiFi网络。如果问题持续存在，可以尝试刷新页面或切换播放线路。爱看影院采用多线CDN加速，正常情况下都能实现秒播不缓冲。',
  },
  {
    id: 'faq-4',
    question: '支持哪些设备观看？',
    answer: '爱看影院全面适配电脑端、平板端和手机端浏览器，你可以在任何设备上直接打开网站观看。同时支持DLNA和AirPlay投屏功能，可以将视频投射到智能电视上享受大屏观影。我们还提供独立的移动客户端App下载。',
  },
  {
    id: 'faq-5',
    question: '剧集更新频率是怎样的？',
    answer: '正在热播的电视剧按照播出平台节奏每日同步更新，通常在首播后2小时内上线。电影新片根据院线下映和网络上线时间及时更新。你可以关注首页的"最新动态"模块获取每日更新资讯。',
  },
  {
    id: 'faq-6',
    question: '遇到播放问题该如何反馈？',
    answer: '如果你在观影过程中遇到任何问题，比如视频无法播放、音画不同步、字幕错误等，欢迎通过"联系我们"模块提供的邮箱或客服渠道反馈。我们的技术团队会尽快处理并回复你。',
  },
];

export const commentItems = [
  {
    id: 'cmt-1',
    name: '光影追梦人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20illustration%20of%20a%20young%20person%20with%20warm%20amber%20background%2C%20clean%20line%20art%20style%2C%20soft%20colors%2C%20friendly%20expression%2C%20modern%20flat%20design%20illustration&width=80&height=80&seq=avatar-1-2026&orientation=squarish',
    date: '2026-07-30',
    rating: 5,
    content: '爱看影院真的是我用过最流畅的在线观影平台！画质清晰加载又快，而且没有烦人的广告弹窗。最近在追《唐朝诡事录之西行》，每集更新都第一时间就能看到，追剧体验满分！',
    source: '来自 App 评价',
  },
  {
    id: 'cmt-2',
    name: '深夜影院迷',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20illustration%20of%20a%20person%20with%20glasses%20in%20warm%20terracotta%20tones%2C%20clean%20line%20art%20style%2C%20soft%20colors%2C%20thoughtful%20expression%2C%20modern%20flat%20design%20illustration&width=80&height=80&seq=avatar-2-2026&orientation=squarish',
    date: '2026-07-29',
    rating: 5,
    content: '作为一个每天都要看一部电影的人，爱看影院的片库真的很全。很多小众文艺片和经典老片这里都有，而且分类做得特别好，找片超方便。4K画质看老电影修复版简直是一种享受。',
    source: '来自微博',
  },
  {
    id: 'cmt-3',
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20illustration%20of%20a%20young%20woman%20with%20warm%20coral%20background%2C%20clean%20line%20art%20style%2C%20soft%20colors%2C%20happy%20expression%2C%20modern%20flat%20design%20illustration&width=80&height=80&seq=avatar-3-2026&orientation=squarish',
    date: '2026-07-28',
    rating: 4,
    content: '最爱的就是每日更新功能，暑假档追了好几部剧，每部更新都特别及时。投屏到电视上和家人一起看，体验超棒！如果能增加一个收藏夹功能就更完美了。',
    source: '来自 App 评价',
  },
  {
    id: 'cmt-4',
    name: '电影考古学家',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20illustration%20of%20a%20person%20with%20beard%20in%20warm%20ochre%20tones%2C%20clean%20line%20art%20style%2C%20soft%20colors%2C%20friendly%20expression%2C%20modern%20flat%20design%20illustration&width=80&height=80&seq=avatar-4-2026&orientation=squarish',
    date: '2026-07-27',
    rating: 5,
    content: '纪录片专区是我的最爱，BBC和央视的经典纪录片这里基本都有。画质特别好，自然纪录片的每一帧都能当壁纸。希望以后能上更多独立纪录片和电影节作品。',
    source: '来自豆瓣',
  },
  {
    id: 'cmt-5',
    name: '周末宅家族',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20illustration%20of%20a%20young%20person%20in%20warm%20sepia%20tones%2C%20clean%20line%20art%20style%2C%20soft%20colors%2C%20relaxed%20expression%2C%20modern%20flat%20design%20illustration&width=80&height=80&seq=avatar-5-2026&orientation=squarish',
    date: '2026-07-26',
    rating: 5,
    content: '朋友推荐的，用了一周就离不开了。界面简洁干净，没有乱七八糟的广告。高清画质秒开秒播，比我之前用的那些平台强太多了。已经推荐给全家人在用了！',
    source: '来自朋友圈分享',
  },
];

export const updateItems = [
  {
    id: 'upd-1',
    date: '2026-07-31',
    tag: '新片上线',
    tagColor: 'accent',
    title: '《云边有个小卖部》高清版正式上线，豆瓣开分 8.7',
  },
  {
    id: 'upd-2',
    date: '2026-07-31',
    tag: '剧集更新',
    tagColor: 'primary',
    title: '《唐朝诡事录之西行》第 18 集已更新，剧情迎来大反转',
  },
  {
    id: 'upd-3',
    date: '2026-07-30',
    tag: '系统公告',
    tagColor: 'secondary',
    title: 'CDN加速节点扩容完成，全网播放速度提升 30%',
  },
  {
    id: 'upd-4',
    date: '2026-07-30',
    tag: '新片上线',
    tagColor: 'accent',
    title: '《暗夜追踪》全 40 集一次性上线，谍战迷不可错过',
  },
  {
    id: 'upd-5',
    date: '2026-07-29',
    tag: '专题上线',
    tagColor: 'primary',
    title: '「暑期档追剧指南」专题页上线，精选 50 部热播好剧',
  },
  {
    id: 'upd-6',
    date: '2026-07-28',
    tag: '剧集更新',
    tagColor: 'primary',
    title: '《庆余年 第二季》大结局已更新，第三季官宣在即',
  },
  {
    id: 'upd-7',
    date: '2026-07-27',
    tag: '功能升级',
    tagColor: 'secondary',
    title: '4K 超清专区正式开放，首批 200 部精选影片支持 4K 播放',
  },
];

export const topicItems = [
  { id: 'top-1', title: '#唐朝诡事录之西行#', posts: '128万', trend: 'hot', category: '剧集热议' },
  { id: 'top-2', title: '#云边有个小卖部#', posts: '96万', trend: 'rising', category: '新片讨论' },
  { id: 'top-3', title: '#暑假追剧计划#', posts: '85万', trend: 'hot', category: '观影活动' },
  { id: 'top-4', title: '#暗夜追踪值得看吗#', posts: '72万', trend: 'rising', category: '剧集热议' },
  { id: 'top-5', title: '#沙丘第三部#', posts: '68万', trend: 'hot', category: '电影期待' },
  { id: 'top-6', title: '#国产剧崛起#', posts: '55万', trend: 'stable', category: '行业讨论' },
  { id: 'top-7', title: '#4K修复经典电影#', posts: '43万', trend: 'rising', category: '观影体验' },
  { id: 'top-8', title: '#悬疑剧推荐#', posts: '38万', trend: 'stable', category: '影迷分享' },
  { id: 'top-9', title: '#国漫新作期待榜#', posts: '31万', trend: 'rising', category: '动漫讨论' },
];

export const cardItems = [
  {
    id: 'crd-1',
    title: '暑期档·热播大剧追更日历',
    description: '一图掌握7-8月所有热播剧集更新节奏，追剧不再错过任何一集。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20calendar%20design%20with%20warm%20amber%20and%20gold%20accents%2C%20movie%20clapperboard%20and%20film%20strip%20decorative%20elements%2C%20clean%20typography%20layout%2C%20sophisticated%20editorial%20design%20aesthetic%2C%20soft%20gradient%20background%20with%20warm%20light%2C%20minimalist%20style%20with%20cinematic%20touches&width=700&height=420&seq=card-1-2026&orientation=landscape',
    date: '7月31日 更新',
    author: '追剧日历',
  },
  {
    id: 'crd-2',
    title: '悬疑剧迷必看：2026上半年十大高分烧脑剧',
    description: '从国产到海外，精选十部让人欲罢不能的悬疑佳作，反转不断。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20mystery%20theme%20design%20with%20magnifying%20glass%20and%20question%20marks%2C%20warm%20amber%20and%20deep%20sepia%20tones%2C%20film%20noir%20aesthetic%2C%20shadowy%20textures%2C%20cinematic%20mood%2C%20editorial%20design%20style%20with%20dramatic%20lighting%20and%20elegant%20typography&width=700&height=420&seq=card-2-2026&orientation=landscape',
    date: '7月29日 发布',
    author: '精选片单',
  },
  {
    id: 'crd-3',
    title: '从零开始的追剧入门：平台使用完全指南',
    description: '新用户必读！手把手教你如何高效使用爱看影院的所有功能。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20cozy%20living%20room%20with%20large%20TV%20screen%20displaying%20a%20movie%2C%20warm%20ambient%20lighting%2C%20comfortable%20sofa%20with%20blanket%2C%20popcorn%20bowl%2C%20golden%20hour%20light%20through%20window%2C%20cinematic%20home%20theater%20atmosphere%2C%20warm%20amber%20tones%2C%20inviting%20and%20relaxed%20composition&width=700&height=420&seq=card-3-2026&orientation=landscape',
    date: '7月25日 发布',
    author: '使用指南',
  },
  {
    id: 'crd-4',
    title: '经典修复：那些值得用4K重看一遍的老电影',
    description: '科技让经典重生。盘点经过4K修复后焕然一新的影史经典作品。',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20projector%20with%20golden%20light%20beam%20projecting%20onto%20a%20minimalist%20screen%2C%20classic%20cinema%20aesthetic%2C%20warm%20sepia%20and%20amber%20tones%2C%20art%20deco%20decorative%20elements%2C%20nostalgic%20atmosphere%2C%20soft%20dust%20particles%20in%20light%20beam%2C%20elegant%20composition%20with%20rich%20textures&width=700&height=420&seq=card-4-2026&orientation=landscape',
    date: '7月22日 发布',
    author: '影史经典',
  },
  {
    id: 'crd-5',
    title: '国漫崛起：2026年最值得期待的十部国产动画',
    description: '从大银幕到网络平台，国产动画正在创造属于自己高光时刻。',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20Chinese%20animation%20style%20landscape%20with%20traditional%20ink%20wash%20painting%20elements%20blending%20with%20modern%20digital%20art%2C%20warm%20golden%20and%20vermilion%20accents%2C%20flowing%20clouds%20and%20mountains%2C%20dreamy%20atmosphere%2C%20harmonious%20composition%20with%20elegant%20Oriental%20aesthetic%20and%20soft%20gradients&width=700&height=420&seq=card-5-2026&orientation=landscape',
    date: '7月20日 发布',
    author: '国漫前瞻',
  },
];

export const aboutNavTitle = '关于爱看影院';
export const featuresNavTitle = '为什么选择我们';
export const topicsNavTitle = '热门话题';
export const cardsNavTitle = '精选推荐';
export const carouselNavTitle = '焦点推荐';